export const GET_ANDROID_CLASSES_LIST = 'GET_ANDROID_CLASSES_LIST';
export const GET_ANDROID_CLASSES_LIST_SUCCESS = 'GET_ANDROID_CLASSES_LIST_SUCCESS';
export const GET_ANDROID_CLASS_APPS = 'GET_ANDROID_CLASS_APPS';
export const GET_ANDROID_CLASS_APPS_SUCCESS = 'GET_ANDROID_CLASS_APPS_SUCCESS';
